import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../services/storage.service';

export const organizationGuard: CanActivateFn = (route, state) => {
  const storage = inject(StorageService);
  const router = inject(Router);

  const role = storage.getItem('role');

  // Super admins are global and don't need a specific organization selected
  if (role === 'super_admin') {
    router.navigate(['/super-admin']);
    return false;
  }

  // Check if organization context is selected
  const activeTenant = storage.getItem('active_tenant');
  if (activeTenant) {
    return true;
  }

  // No organization selected, redirect to workspace selector
  router.navigate(['/auth/organization-selection']);
  return false;
};
